import React from "react";

export default function MessagingPanelShell({
  icon: Icon,
  title,
  subtitle,
  toolbar,
  children,
}) {
  return (
    <section>
      <div className="border-b border-slate-200/70 bg-white/70 px-3 py-3 dark:border-slate-800 dark:bg-slate-900/60 sm:px-5">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            {Icon && (
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-slate-950 text-white dark:bg-white dark:text-slate-950">
                <Icon />
              </div>
            )}

            <div>
              <h3 className="text-base font-bold text-slate-950 dark:text-white sm:text-lg">
                {title}
              </h3>

              {subtitle && (
                <p className="mt-0.5 text-xs leading-5 text-slate-500 dark:text-slate-400">
                  {subtitle}
                </p>
              )}
            </div>
          </div>

          {toolbar}
        </div>
      </div>

      <div className="p-3 sm:p-5 lg:p-6">{children}</div>
    </section>
  );
}